module.exports = __webpack_public_path__ + "static/media/V-ID-8.9354f867.mp4";